import { FC } from 'react';
import styled from 'styled-components';

import { Td } from '@/components/Table';
import { SponsornameResource } from '@/types/resources';

import { formatNumberWithCommas } from '../../../utils/helpers';
import SponsornameStatsBadge from './SponsornameStatsBadge';

const TdInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

interface Props {
  sponsor: SponsornameResource;
  baseValues?: SponsornameResource[];
}

const SponsornameTableRow: FC<Props> = ({ sponsor, baseValues }) => {
  const baseValue = baseValues?.find(
    (base) =>
      base.sponsor.replace(/_\d+$/, '') ===
      sponsor.sponsor.replace(/_\d+$/, ''),
  );

  return (
    <tr>
      <Td>{sponsor.sponsor}</Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageAvgScroll)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageAvgScroll}
            baseValue={baseValue?.pageAvgScroll}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageAvgTime)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageAvgTime}
            baseValue={baseValue?.pageAvgTime}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.avgTimePerView)}
          <SponsornameStatsBadge
            currentValue={sponsor.avgTimePerView}
            baseValue={baseValue?.avgTimePerView}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageScrollStarts)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageScrollStarts}
            baseValue={baseValue?.pageScrollStarts}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageTotalTime)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageTotalTime}
            baseValue={baseValue?.pageTotalTime}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageUniques)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageUniques}
            baseValue={baseValue?.pageUniques}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageViews)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageViews}
            baseValue={baseValue?.pageViews}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageViewsLoyal)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageViewsLoyal}
            baseValue={baseValue?.pageViewsLoyal}
          />
        </TdInner>
      </Td>
      <Td>
        <TdInner>
          {formatNumberWithCommas(sponsor.pageViewsQuality)}
          <SponsornameStatsBadge
            currentValue={sponsor.pageViewsQuality}
            baseValue={baseValue?.pageViewsQuality}
          />
        </TdInner>
      </Td>
    </tr>
  );
};

export default SponsornameTableRow;
